import { Link } from "react-router-dom";
import { FcMoneyTransfer, FcOrgUnit } from "react-icons/fc";
import { BsCashStack } from "react-icons/bs";
import { FaUsersLine, FaUmbrellaBeach } from "react-icons/fa6";
import HandleCurrentPath from "./HandleCurrentPath";
import { TbBeach, TbBeachOff } from "react-icons/tb";
import { GiBeachBucket } from "react-icons/gi";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import { IoShareSocialSharp } from "react-icons/io5";
import { FaFileInvoice, FaCashRegister } from "react-icons/fa";

const Menu = () => {
  const pathname = window.location.pathname;

  return (
    <>
      <ul className="mt-6">
        <li className="relative px-6 py-3">
          <HandleCurrentPath staticPath={"/"} currentPath={pathname} />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold text-gray-800 transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200 dark:text-gray-100"
            to={"/"}
          >
            <FcOrgUnit />
            <span className="ml-4">Dashboard</span>
          </Link>
        </li>
      </ul>

      <ul>
        <li className="relative px-6 py-3">
          <HandleCurrentPath staticPath={"/client"} currentPath={pathname} />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/client"}
          >
            <FaUsersLine />
            <span className="ml-4">Client </span>
          </Link>
        </li>

        <li className="relative px-6 py-3">
          <HandleCurrentPath
            staticPath={"/maTravelPackage"}
            currentPath={pathname}
          />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/maTravelPackage"}
          >
            <FaUmbrellaBeach className="text-[oklch(78.9%_0.154_211.53)]" />
            <span className="ml-4">Travel Packages </span>
          </Link>
        </li>

        <li className="relative px-6 py-3">
          <HandleCurrentPath
            staticPath={"/mapackageitem"}
            currentPath={pathname}
          />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/mapackageitem"}
          >
            <GiBeachBucket />
            <span className="ml-4">Travel Package Items </span>
          </Link>
        </li>

        <li className="relative px-6 py-3">
          <HandleCurrentPath
            staticPath={"/matravelpackageinclusion"}
            currentPath={pathname}
          />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/matravelpackageinclusion"}
          >
            <TbBeach />
            <span className="ml-4">Travel Package Inclusions </span>
          </Link>
        </li>

        <li className="relative px-6 py-3">
          <HandleCurrentPath
            staticPath={"/matravelpackageexclusion"}
            currentPath={pathname}
          />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/matravelpackageexclusion"}
          >
            <TbBeachOff className="text-[oklch(64.5%_0.246_16.439)]" />
            <span className="ml-4">Travel Package Exclusions </span>
          </Link>
        </li>

        <li className="relative px-6 py-3">
          <HandleCurrentPath staticPath={"/invoices"} currentPath={pathname} />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/invoices"}
          >
            <LiaFileInvoiceDollarSolid />
            <span className="ml-4">Invoices </span>
          </Link>
        </li>

        <li className="relative px-6 py-3">
          <HandleCurrentPath
            staticPath={"/companypaymentdetail"}
            currentPath={pathname}
          />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/companypaymentdetail"}
          >
            <BsCashStack />
            <span className="ml-4">Company Payment Details </span>
          </Link>
        </li>

        <li className="relative px-6 py-3">
          <HandleCurrentPath
            staticPath={"/invoiceSocial"}
            currentPath={pathname}
          />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/invoiceSocial"}
          >
            <IoShareSocialSharp className="text-[oklch(79.2%_0.209_151.711)]" />
            <span className="ml-4">Invoice Socials </span>
          </Link>
        </li>

        <li className="relative px-6 py-3">
          <HandleCurrentPath
            staticPath={"/invoicefooterdetail"}
            currentPath={pathname}
          />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/invoicefooterdetail"}
          >
            <FaFileInvoice />
            <span className="ml-4">Invoice Footer Detail </span>
          </Link>
        </li>

        <li className="relative px-6 py-3">
          <HandleCurrentPath
            staticPath={"/invoicefooterbgcolor"}
            currentPath={pathname}
          />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/invoicefooterbgcolor"}
          >
            <FaFileInvoice className="text-[oklch(54.6%_0.245_262.881)]" />
            <span className="ml-4">Invoice Footer BGColor </span>
          </Link>
        </li>
        <li className="relative px-6 py-3">
          <HandleCurrentPath
            staticPath={"/invoicepayment"}
            currentPath={pathname}
          />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/invoicepayment"}
          >
            <FcMoneyTransfer />
            <span className="ml-4">Invoice Payment </span>
          </Link>
        </li>

        <li className="relative px-6 py-3">
          <HandleCurrentPath
            staticPath={"/invoiceregister"}
            currentPath={pathname}
          />
          <Link
            className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-150 hover:text-gray-800 dark:hover:text-gray-200"
            to={"/invoiceregister"}
          >
            <FaCashRegister />
            <span className="ml-4">Invoice Register </span>
          </Link>
        </li>
      </ul>
    </>
  );
};
export default Menu;
